import React from 'react';
import RequestLoader from './RequestLoader';
export default function Fallback() {
	return (
		<section className="fallback-page">
			<RequestLoader />
		</section>
	);
}
